module.exports = __webpack_public_path__ + "static/media/T10 - Cordusio.d4ba8d73.jpg";